export function data() {
  return {
    file: [],
    image: null,
    documentIds: [],
    previews: []
  }
}
